/**
 * Boomfection Landing — Friends Module
 * Friends list loading
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 *
 * XSS-SAFE: All dynamic strings passed through escapeHtml(). Static badge
 * labels are hardcoded constants. This code is moved verbatim from landing.js.
 */

import { safeJsonFetch } from './LandingUtils.js';
import { t } from '/js/i18n.js';

/**
 * Loads the friends list for the current player
 * @param {string|null} currentPlayerNickname - fallback nickname if no input value
 */
export async function loadFriendsList(currentPlayerNickname) {
    const container = document.getElementById('friends-list');
    if (!container) return;

    const myName = document.getElementById('create-name')?.value || currentPlayerNickname;
    if (!myName) {
        container.textContent = '';
        const hint = document.createElement('div');
        hint.className = 'text-muted text-center';
        hint.textContent = t('friends.enterName');
        container.appendChild(hint);
        return;
    }

    try {
        const data = await safeJsonFetch(`/api/friends/${encodeURIComponent(myName)}`);
        if (!data || !data.friends || data.friends.length === 0) {
            container.textContent = '';
            const empty = document.createElement('div');
            empty.className = 'text-muted text-center';
            empty.textContent = t('friends.noFriends');
            container.appendChild(empty);
            return;
        }

        container.textContent = '';
        const fragment = document.createDocumentFragment();
        data.friends.forEach(function (f) {
            const row = document.createElement('div');
            row.className = 'friend-row';

            const nameSpan = document.createElement('span');
            nameSpan.className = 'friend-name';
            nameSpan.textContent = f.nickname;

            const statusSpan = document.createElement('span');
            if (f.status === 'accepted') {
                statusSpan.className = f.isOnline ? 'friend-online' : 'friend-offline';
                statusSpan.textContent = f.isOnline ? t('friends.online') : t('friends.offline');
            } else {
                statusSpan.className = 'friend-pending';
                statusSpan.textContent = t('friends.pending');
            }

            row.appendChild(nameSpan);
            row.appendChild(statusSpan);
            fragment.appendChild(row);
        });
        container.appendChild(fragment);
    } catch (err) {
        console.error('[Friends] Load error:', err);
    }
}
